import Helmet from "react-helmet";

const HeadTags = (props) => {
  const {
    title = "Portfolio - your name",
    metaDescription = "defaul tdescription",
    keys="keywords",
    author="Lontoone",
    img=""
  } = props;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="description" key="description" content={metaDescription} />
      <meta name="title" key="title" content={title} />
      <meta property="og:title" key="og:title" content={title} />
      <meta property="og:locale" key="og:locale" content="en_US" />
      <meta charSet="utf-8" />
      <meta property="og:type" key="og:type" content="website" />
      <meta name="keywords" content={keys} data-react-helmet="true" />
      <meta
        property="og:description"
        key="og:description"
        content={metaDescription}
      />
      <meta
        property="og:image"
        key="og:image"
        content={`${process.env.BASE_URL}/images/frontend.jpeg`}
      />
      <meta name="url" property="og:url" content={window.location}  data-react-helmet="true" />
      <meta name="author" content={author} data-react-helmet="true"  />
      <meta name="image" property="og:image" content={img}  data-react-helmet="true" />
    </Helmet>
  );
};

export default HeadTags